import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logout from "../../Image/logout.svg";
import img2 from "../../Image/Logo.png";

const Navbar2 = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const C_State = location.pathname.replaceAll("/", "");

    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="fixed top-0 w-full bg-main-white text-main-font shadow-md z-50">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Left Side */}
          <div className="flex items-center gap-4">
            {/* Logo */}
            <img
              src={img2}
              alt="Application Logo"
              className="h-9 w-9 md:h-11 md:w-11 cursor-pointer transition hover:scale-105 hidden md:block rounded-lg"
              onClick={() => navigate("/")}
            />
          </div>

          {/* Right Side (Desktop Only) */}
          <div className="hidden md:flex items-center gap-6">
            <button
              className="flex items-center justify-center rounded-lg p-1 transition-all duration-200 hover:bg-gray-100 hover:scale-105"
              onClick={() => navigate("/logout")}
            >
              <img src={logout} className="w-7 h-7" alt="logout" />
            </button>
          </div>

          {/* Mobile Menu Toggle Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-main-font hover:text-main-blue focus:outline-none"
            >
              {isMobileMenuOpen ? (
                <svg
                  className="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu (unchanged per request) */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <div
                className="block px-3 py-2 rounded-md text-base font-medium text-main-font hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  navigate("/logout");
                  toggleMobileMenu();
                }}
              >
                Logout
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar2;
